import styled from 'styled-components'

import { Div } from 'components'
import { STATIC_FILES_CDN_URL } from 'constant'
import { elementStyle } from 'styles/element-style'

export const StyledDiv = styled(Div)`
  ${elementStyle}
  display: block;
  height: 120px;
  text-align: center;
  background-image: url('${STATIC_FILES_CDN_URL}hero-banner-bg.svg');
  background-size: cover;
`

export const ButtonContainer = styled(Div)`
  ${elementStyle}
  display: flex;
  justify-content: center;
  gap: 20px;
  @media (max-width: 991px) {
    gap: 10px;
  }
`
export const DescriptionText = styled.p`
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
`
